import { assembleCompanyView } from "@/company/data/assemble-company-view";
import type { CompanyViewModel } from "@/company/core/types";
import { fetchGridRawData } from "@/grid/data/fetch-grid-data";
import type { DepartmentDefinition } from "@/grid/core/types";
import { nowToronto } from "@/grid/core/periods";
import { useQuery } from "@tanstack/react-query";

export function useCompanyData(department: DepartmentDefinition) {
  return useQuery<CompanyViewModel, Error>({
    queryKey: ["company", department.id],
    queryFn: async () => {
      const yearStart = `${nowToronto().getFullYear()}-01-01`;
      const raw = await fetchGridRawData(department, nowToronto(), {
        dailyFrom: yearStart,
        periodFrom: yearStart,
      });
      return assembleCompanyView(department, raw);
    },
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
